import PropTypes from 'prop-types';
import React from 'react';

const SidebarLockedItem = props => {
  const { children, onClick } = props;

  return (
    <li className="disabled" onClick={onClick}>
      <a>
        <i className="glyphicon glyphicon-lock" />
        {children}
      </a>
    </li>
  );
};

SidebarLockedItem.propTypes = {
  onClick: PropTypes.func,
};

SidebarLockedItem.defaultProps = {
  onClick: () => {},
};

export default SidebarLockedItem;
